import { withSvgIcon } from './withSvgIcon';

export const XIcon = withSvgIcon(
  <path
    d="M17.511 3.17h2.913l-6.395 7.283 7.471 9.88h-5.863l-4.59-6.004-5.255 6.004H2.88l6.774-7.79L2.5 3.17h6.008l4.147 5.485 4.856-5.485Zm-1.019 15.453h1.614L7.66 4.817H5.925l10.567 13.806Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
